import { useEffect, useRef, useState } from 'react'

const useSeeMore = () => {
  const r = useRef<HTMLDivElement>(null)
  const [isOpen, setIsOpen] = useState(false)
  const [seeMore, setSeeMore] = useState(false)

  useEffect(() => {
    if (!r.current) {
      return
    }
    if (r.current.scrollHeight > r.current.clientHeight) {
      setSeeMore(true)
    }
  }, [r])

  return { isOpen, r, setIsOpen, seeMore }
}

export default useSeeMore
